import * as React from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import Image from "../../../ui-components/Image";
import Audio from "../../../ui-components/Audio";

export default function MultipleChoiceObjectAudio({
	question,
	onAnswer = () => {},
}) {
	const questions = question.questionList || [];
	const answerKeys = question.answerKeys || [];
	const [answer, setAnswer] = React.useState({});

	React.useEffect(() => {
		setAnswer({});
	}, [question]);

	const handleSetAnswer = (choice, index) => {
		const key = answerKeys[index];
		const newAnswer = { ...answer, [key]: choice };
		setAnswer(newAnswer);

		const canProceed = answerKeys.every((k) => newAnswer[k]);

		onAnswer({
			canProceed,
			answer: newAnswer,
		});
	};

	return (
		<React.Fragment>
			{question.questionImage && (
				<Box
					sx={{
						width: "100%",
						background: "white",
						pb: 2,
						pt: 1,
						px: 1,
					}}
					className="image-container"
				>
					<Image src={question.questionImage} />
				</Box>
			)}
			{question.questionAudio && (
				<Box sx={{ mb: 1 }}>
					<Audio audioText={question.questionAudio} />
				</Box>
			)}

			<Box className="choices-container">
				{questions.map((q, i) => (
					<Box sx={{ mt: 3 }} key={`question-${i}`}>
						<Grid container justifyContent="center">
							<Grid item sm={12} sx={{ textAlign: "center" }}>
								<Typography variant="qlist_text">
									{q.text}
								</Typography>
							</Grid>
						</Grid>
						<Grid
							container
							gap={1}
							justifyContent="center"
							sx={{ mt: 1 }}
						>
							{q.choices.map((choice, j) => (
								<Grid item sm={5} xs={5} key={`choices-${j}`}>
									<Button
										variant={
											answer[answerKeys[i]] ===
											(choice?.value || choice)
												? "contained"
												: "outlined"
										}
										fullWidth
										size="large"
										sx={{
											fontSize: "1.2rem",
											px: 1,
											lineHeight: "1.2em",
										}}
										onClick={() =>
											handleSetAnswer(
												choice?.value || choice,
												i
											)
										}
									>
										{choice?.label || choice}
									</Button>
								</Grid>
							))}
						</Grid>
					</Box>
				))}
			</Box>
		</React.Fragment>
	);
}
